import { http } from "../utils/http";
export const customerQuery = (data) =>
  http.post("/weilan/api/customer/info/query", data);
export const customerDel = (data) =>
  http.post("/weilan/api/customer/info/delete", data);
export const customerAdd = (data) =>
  http.post("/weilan/api/customer/info/add", data);
export const customerEdit = (data) =>
  http.post("/weilan/api/customer/info/modify", data);
